import { render, staticRenderFns } from "./ChangeDeviceStatus.vue?vue&type=template&id=36881f00&scoped=true"
import script from "./ChangeDeviceStatus.vue?vue&type=script&lang=ts"
export * from "./ChangeDeviceStatus.vue?vue&type=script&lang=ts"
import style0 from "./ChangeDeviceStatus.vue?vue&type=style&index=0&id=36881f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36881f00",
  null
  
)

export default component.exports